// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Código de erro:",
    "error.search": "Pesquisa na nossa base de conhecimento para saber mais",
    dismiss: "dispensar",
    "installation.title": "",
    "cancelation.button": "Cancelar",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Não foi possível inicializar",
      description:
        "Não foi possível renderizar a página. Entre em contato com o suporte.",
    },
    "EOS-UI-UE": {
      title: "Alguma coisa deu errado.",
      description: "Alguma coisa deu errado. Entre em contato com o suporte.",
    },
    "EOS-IN-BC": {
      title: "Falha na instalação",
      description:
        "Não foi possível exibir o progresso da instalação. Entre em contato com o suporte.",
    },
    "EOS-IN-UE": {
      title: "Falha na instalação",
      description: "Alguma coisa deu errado. Entre em contato com o suporte.",
    },
    "EOS-IN-FF": {
      title: "Falha na instalação",
      description:
        "Não foi possível se conectar ao Epic Online Services. Entre em contato com o suporte.",
    },
    "EOS-IN-FF-*": {
      title: "Falha na instalação",
      description:
        "Não foi possível enviar a solicitação para Epic Online Services. Entre em contato com o suporte.",
    },
    fallback: {
      title: "Alguma coisa deu errado.",
      description: "Alguma coisa deu errado. Entre em contato com o suporte.",
    },
  },
};
